import React from 'react';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface SignInIconProps {
  size?: number;
  color?: keyof AppColors;
  strokeWidth?: number;
}

export const SignInIcon: React.FC<SignInIconProps> = ({
  size = 44,
  color = 'iconPrimary',
  strokeWidth,
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 44 44">
      <Path
        d="M3.6962 11.1006C7.24007 5.63045 13.3682 2.02105 20.3308 2.02105C31.2848 2.02105 40.1758 10.9598 40.1758 22C40.1758 33.0402 31.2848 41.979 20.3308 41.979C13.3682 41.979 7.24007 38.3695 3.6962 32.8994L2 33.9982C5.8985 40.0158 12.6508 44 20.3308 44C32.4131 44 42.1968 34.1442 42.1968 22C42.1968 9.85585 32.4131 0 20.3308 0C12.6508 0 5.8985 3.98417 2 10.0018L3.6962 11.1006Z"
        fill={colors[color]}
        strokeWidth={strokeWidth}
      />
      <Path
        d="M2.26153 23.0113H23.1747L17.3842 28.839L18.8179 30.2635L26.3207 22.7125C26.7123 22.3183 26.7123 21.682 26.3207 21.2879L18.8179 13.7369L17.3842 15.1614L23.1759 20.9903H2.26153V23.0113Z"
        fill={colors[color]}
        strokeWidth={strokeWidth}
      />
    </Svg>
  );
};
